module.exports = __webpack_public_path__ + "img/qrVector.b7d0b891.svg";